import { useEffect } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../config/firebase";

function VisitorTracker() {
  useEffect(() => {
    // On vérifie si le visiteur a déjà le "ticket" pour cette session
    const hasVisited = sessionStorage.getItem("acefund_visited");

    if (!hasVisited) {
      const recordVisit = async () => {
        try {
          // On enregistre la date et l'heure exactes
          await addDoc(collection(db, "visits"), {
            date: new Date().toISOString(),
          });
          // On donne le "ticket" au navigateur pour ne plus le recompter
          sessionStorage.setItem("acefund_visited", "true");
        } catch (error) {
          console.error("Erreur de tracking :", error);
        }
      };

      recordVisit();
    }
  }, []);

  return null; // Ce composant est 100% invisible
}

export default VisitorTracker;
